<form [class.working]="toggle.working" [formGroup]="offerAccepted" (ngSubmit)="offerAcceptedSubmit($event)">

  <div class="lib-flex working" [hidden]="!toggle.working">
    <!-- <span class="lib-spacer"></span>
    <lib-icon name="searching"></lib-icon>
    <p>Saving...</p>
    <span class="lib-spacer"></span> -->
    <app-working></app-working>
  </div>

  <div class="header" [hidden]="toggle.working">

    <div>
      <h3>Offer accepted? Congratulations!</h3>
      <p class="lib-legend">Please confirm a few details.</p>
    </div>

    <span class="lib-spacer"></span>

    <div [ngSwitch]="!!selected">
      <lib-thumbnail type="minimal" *ngSwitchCase="true" [data]="selected?.listing"></lib-thumbnail>
    </div>

    <span class="lib-spacer"></span>

    <div>
      <lib-select theme="stroked" formControlName="favourite" [options]="favourites | async" data-test="select-home-offer"></lib-select>
    </div>

    <button type="button" class="lib-button" (click)="close($event)">
      <lib-icon name="close"></lib-icon>
    </button>

  </div>

  <div [hidden]="toggle.working">

    <div>
      <p class="lib-legend">Price</p>
      <lib-input prefixIcon="gbp" type="currency" formControlName="price" placeholder="">
      </lib-input>
    </div>

    <div>
      <p class="lib-legend">Full postcode</p>
      <lib-input type="text" formControlName="postcode" placeholder="e.g. N1 5AE" data-test="postcode-listing-accepted"></lib-input>
    </div>

    <div>
      <p class="lib-legend">Surface area&nbsp;m<sup>2</sup></p>
      <lib-input formControlName="surface_area" type="number" [placeholder]="selected?.surface_area || 0"></lib-input>
    </div>

    <div>
      <p class="lib-legend">Type</p>
      <lib-select theme="stroked" formControlName="property_type" [options]="propertyTypeOptions"></lib-select>
    </div>

    <div>
      <p class="lib-legend">Phone number</p>
      <lib-input type="text" formControlName="phone" data-test="phone-listing-accepted"></lib-input>
    </div>

    <nav class="lib-nav sticky">
      <button type="button" class="lib-button" (click)="close($event)">
        <span>Cancel</span>
      </button>
      <span class="lib-spacer"></span>
      <button [disabled]="!offerAccepted.valid" type="submit" class="lib-button-flat-primary" data-test="accept-offer-button">
        <span>Confirm</span>
      </button>
    </nav>

  </div>

</form>
